import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { AuthGuard } from '@auth0/auth0-angular';

import { NotFoundPageComponent } from './pages/not-found/not-found-page.component';
import { ManageZonesPageComponent } from './pages/manage-zones/manage-zones-page.component';
import { ZoneEditorComponent } from './pages/manage-zones/zones-drawer/zone-editor/zone-editor.component';
import { CreateZoneComponent } from './pages/manage-zones/zones-drawer/create-zone/create-zone.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'manage-zones',
  },
  {
    path: 'manage-zones',
    component: ManageZonesPageComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'zone-editor', component: ZoneEditorComponent },
      { path: 'create-zone', component: CreateZoneComponent },
      { path: '', redirectTo: 'zone-editor', pathMatch: 'full' },
    ]
  },
  {
    path: '**',
    component: NotFoundPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
